module.exports = __webpack_public_path__ + "static/media/eduPurple.59fd891c.svg";